module.exports = __webpack_public_path__ + "static/media/unitedarabemirates.309100e4.svg";